import * as actionTypes from '@/store/action-types'
import * as auth from '@/api/auth'
import * as profile from '@/api/profile'
import * as invoice from '@/api/invoice'
import * as rent from '@/api/rent'
import * as park from '@/api/park'
import * as refill from '@/api/refill'
import * as cod from '@/api/cod'
import * as carsharing from '@/api/carsharing'
import * as coupon from '@/api/coupon'
import {Params, VuexParams} from "@/interfaces/actionParamsInterface";
import {AxiosResponse} from "axios";

export default {
    /**
     * Logout
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.LOGOUT] ({ commit }: VuexParams, { data, callback }: Params) {
        auth.logout({ commit }, { data, callback })
    },
    /**
     * Get Profile
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.GET_PROFILE] ({ commit }: VuexParams, { callback }: Params) {
        profile.getProfile({ commit }, {
            callback: (response?: AxiosResponse|{error?: any, data?:any}) => {
                if (response?.data) {
                    commit('updateConnectedUser', response.data)
                }
                callback(response)
            }
        })
    },
    /**
     * Get Supporting Documents
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.GET_SUPPORTING_DOCUMENTS] ({ commit }: VuexParams, { callback }: Params) {
        profile.getSupportingDocuments({ commit }, { callback })
    },
    /**
     * Update User Address
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.UPDATE_USER_ADDRESS] ({ commit }: VuexParams, { callback, data }: Params) {
        profile.updateUserAddress({ commit }, {data, callback })
    },
    /**
     * Update User Profile
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.UPDATE_USER_PROFILE] ({ commit }: VuexParams, { callback, data }: Params) {
        profile.updateUserProfile({ commit }, {data, callback })
    },
    /**
     * Send Supporting Document
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.SEND_SUPPORTING_DOCUMENT] ({ commit }: VuexParams, { callback, data }: Params) {
        profile.sendSupportingDocument({ commit }, {data, callback })
    },
    /**
     * Get Invoices
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.GET_INVOICES] ({ commit }: VuexParams, { callback, data }: Params) {
        invoice.getInvoices({ commit }, { callback, data })
    },
    /**
     * Get coupons
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.GET_COUPONS] ({ commit }: VuexParams, { callback, data }: Params) {
        coupon.getCoupons({ commit }, { data, callback })
    },
    /**
     * Get rents
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.GET_RENTS] ({ commit }: VuexParams, { callback, data }: Params) {
        rent.getRents({ commit }, { data, callback })
    },
    /**
     * Get carsharings
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.GET_CARSHARINGS] ({ commit }: VuexParams, { callback, data }: Params) {
        carsharing.getCarsharings({ commit }, { data, callback })
    },
    /**
     * Get parks
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.GET_PARKS] ({ commit }: VuexParams, { callback, data }: Params) {
        park.getParks({ commit }, { data, callback })
    },
    /**
     * Get cod contracts
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.GET_COD_CONTRACTS] ({ commit }: VuexParams, { callback, data }: Params) {
        cod.getCodContracts({ commit }, { data, callback })
    },
    /**
     * Get refills
     * @param commit
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.GET_REFILLS] ({ commit }: VuexParams, { callback, data }: Params) {
        refill.getRefills({ commit }, { data, callback })
    },
    /**
     * Add Coupon
     * @param commit
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.ADD_COUPON] ({ commit }: VuexParams, { callback, data }: Params) {
        coupon.addCoupon({ commit }, { data, callback })
    },
    /**
     * Send Data download request
     * @param commit
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.SEND_DOWNLOAD_DATA_REQUEST] ({ commit }: VuexParams, { callback, data }: Params) {
        profile.sendDownloadDataRequest({ commit }, { data, callback })
    },
    /**
     * Unsuscribe newsletter
     * @param commit
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.UNSUBSCRIBE_NEWSLETTER] ({ commit }: VuexParams, { callback, data }: Params) {
        profile.unsubscribeNewsletter({ commit }, { data, callback })
    },
    /**
     * Subscribe newsletter
     * @param commit
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.SUBSCRIBE_NEWSLETTER] ({ commit }: VuexParams, { callback, data }: Params) {
        profile.subscribeNewsletter({ commit }, { data, callback })
    },
    /**
     * Get Braze Status newsletter
     * @param commit
     * @param commit
     * @param {Object} data
     * @param {Function} callback
     */
    [actionTypes.GET_BRAZE_STATUS] ({ commit }: VuexParams, { callback, data }: Params) {
        profile.getBrazeStatus({ commit }, { data, callback })
    }
}
